var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"upload"},[_c('svg-sprite',{attrs:{"icon-id":"icon_download","width":"80","height":"80"}}),_c('span',[_vm._v("Upload file")]),_c('input',{staticStyle:{"display":"none"},attrs:{"accept":".xlsx","type":"file"},on:{"change":_vm.onFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }